const colors = require("@mui/material/colors");
const { createTheme } = require("@mui/material/styles");

const defaultTheme = createTheme();
const linksColor = {
	lighter: "#009696",
	light: "#007373",
	main: "#005c5c",
	dark: "#004d4d",
	darker: "#003838",
	contrastText: defaultTheme.palette.getContrastText("#007373"),
};
const lightColor = {
	lighter: "#fff",
	light: colors.grey["100"],
	main: colors.grey["100"],
	dark: colors.grey["200"],
	darker: colors.grey["200"],
	contrastText: defaultTheme.palette.getContrastText(colors.grey["100"]),
};
const blueColor = {
	lighter: "#185099",
	light: "#133f78",
	main: "#0c2c56",
	dark: "#092242",
	darker: "#06162b",
	contrastText: defaultTheme.palette.getContrastText("#0c2c56"),
};

const headingsTypography = {
	fontFamily: "Glegoo, Helvetica Neue, Arial, sans-serif",
	fontWeight: 700,
	lineHeight: 1.3,
};

const regularTypography = {
	fontFamily: "'Public Sans', Arial, Helvetica Neue, sans-serif",
	fontWeight: 400,
};

const themeConfig = {
	typography: {
		...regularTypography,
		fontSize: 16,
		fontWeightBold: 700,
		h1: {
			...headingsTypography,
		},
		h2: {
			...headingsTypography,
		},
		h3: {
			...headingsTypography,
			fontSize: "1.4rem",
		},
		h4: {
			...regularTypography,
			fontWeight: 700,
		},
		h5: {
			...regularTypography,
			fontWeight: 700,
		},
		h6: {
			...regularTypography,
			fontWeight: 700,
		},
		nav: {
			...regularTypography,
			fontWeight: 700,
			textTransform: "uppercase",
			fontSize: "0.875rem",
			paddingTop: "1rem",
		},
		subnav: {
			textTransform: "none",
			fontSize: "1rem",
		},
		toolsNav: {
			...regularTypography,
			fontWeight: 400,
			textTransform: "uppercase",
			fontSize: "0.875rem",
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				text: {
					fontSize: "1.475rem",
				},
				contained: {
					fontSize: "1.075rem",
					fontWeight: 700,
					padding: "8px 22px",
				},
			},
		},
	},
	palette: {
		body: {
			light: "#fafafa",
		},
		link: { ...linksColor },
		blue: {
			...blueColor,
		},
		divider: "rgba(0, 0, 0, 0.12)",
		primary: {
			light: "#424242",
			main: "#212121",
			dark: "#0a0a0a",
			contrastText: defaultTheme.palette.getContrastText("#212121"),
		},
		footer: {
			main: "#212121",
			contrastText: defaultTheme.palette.getContrastText("#212121"),
		},
		colophon: {
			main: "#212121",
			contrastText: defaultTheme.palette.getContrastText("#212121"),
		},
		appBar: {
			public: {
				...lightColor,
				contrastText: defaultTheme.palette.getContrastText(lightColor.main),
			},
		},
		titleBar: {
			public: {
				...blueColor,
			},
		},
		tab: {
			paper: "#eeeeee",
			main: "#eeeeee",
			contrastText: "#212121",
			hover: "#212121",
			contrastTextHover: "#eeeeee",
		},
		subnav: {
			contrastText: "#757575",
		},
	},
	cloverleaf: {
		googleFont: "Glegoo:wght@400;700&family=Public+Sans:wght@300;500;700",
		navbar: {
			align: "right",
			padding: 2.15,
			borderRadius: 9,
		},
		footer: {
			disableFooterBrand: true,
		},
		brand: {
			size: 80,
			paddingTop: 0.001,
			paddingBottom: 0.001,
		},
		css: `
			#___gatsby .title-bar {
				background-size: cover !important;
				background-color: #0c2c56 !important;
				background-image: url(/arches-blu.png) !important;
				background-position: center center !important;
				background-blend-mode: luminosity !important;
			}
			#___gatsby .desktop-nav {
				position: relative;
			}
			#___gatsby .desktop-nav::before {
				content: '';
				position: absolute;
				top: 0;
				right: 0;
				width: 100%;
				height: 1px;
				background-image: linear-gradient(90deg, hsla(0, 0%, 100%, 0.52) 28%, rgba(33, 63, 101, 0.21));
			}
      #___gatsby .title-blog .variant-overline {
        letter-spacing: 0em;
        font-size: 1rem;
      }
		`,
	},
};
module.exports = themeConfig;
